import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const isModifiedClick = (e) => e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;

export const useRouterLink = () => {
    const navigate = useNavigate();

    return useCallback(
        (to, onNavigate) => ({
            href: to,
            onClick: (e) => {
                if (e.defaultPrevented || isModifiedClick(e)) return;
                e.preventDefault();
                onNavigate?.();
                navigate(to);
            },
        }),
        [navigate]
    );
};
